import React from 'react';

import { Input } from 'components/shared/Input';

const InputField = ({ field, form, ...restProps }) => (
  <Input {...field} {...restProps} />
);

export default React.memo(InputField);
